var map = {
	"./X.svg": 61770,
	"./button.svg": 92486,
	"./card-games.svg": 79774,
	"./chevron-down.svg": 95420,
	"./chevron-right.svg": 59822,
	"./contentCopy.svg": 88414,
	"./cross.svg": 7838,
	"./discord.svg": 32338,
	"./eye-off.svg": 86933,
	"./gift-1.svg": 14214,
	"./icon-game.svg": 84396,
	"./money-1.svg": 52220,
	"./right-arrow.svg": 38036,
	"./send.svg": 62608,
	"./tick-green.svg": 59907,
	"./wallet-1.svg": 20003
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91980;